import React from 'react';
import './LiquiditySummarySettings.scss';
import AppSettingsEditor from 'appToolbar/AppSettingsEditor';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';

export default function LiquiditySummarySettings() {
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();

    return (
        <div className="LiquiditySummarySettings group group-general">
            <AppSettingsEditor
                appSettings={appSettings}
                onAppSettingsChanged={dispatchUpdateAppSettings}
                specifyVisibleControls={{
                    currency: true,
                    symbology: true,
                }}
            ></AppSettingsEditor>
        </div>
    );
}
